module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/how-works-desktop.459d4b02.svg";